import { CreditCard, Plug, User, Users } from 'lucide-react';
import { NavTabs } from '@/components/ui/nav-tabs';

/**
 * Shared horizontal tab row used at the top of every Settings page. Lives
 * in one place so adding a new settings sub-page is a one-line change.
 */
export function SettingsTabs(): JSX.Element {
  return (
    <NavTabs
      items={[
        { to: '/settings/account', label: 'Account', icon: User },
        { to: '/settings/members', label: 'Members', icon: Users },
        { to: '/settings/billing', label: 'Billing', icon: CreditCard },
        {
          to: '/settings/integrations',
          label: 'Integrations',
          icon: Plug,
        },
      ]}
    />
  );
}
